import { Flex, Image, Text } from "@chakra-ui/react"

const Document = ({ documentText, documentUrl }) => {
  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener, noreferrer")
    if (newWindow) newWindow.opener = null
  }

  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      boxShadow="md"
      borderRadius="4px"
      padding="8px"
      margin="8px"
      _hover={{ transform: "scale(1.1)", cursor: "pointer" }}
      onClick={() => openInNewTab(documentUrl)}
    >
      <Image
        src="/cez-confort-asigurat/assets/document.png"
        alt="documente"
        marginTop="8px"
      />
      <Text fontSize="xs" fontWeight="bold" marginTop="16px">
        {documentText}
      </Text>
    </Flex>
  )
}

export default Document
